import { Component, OnInit } from '@angular/core';
import {
  LoginModel,
  RegistrationStepQuery,
  RegistrationStepService,
  StepType,
  LoggingService,
  InputField,
  InputType,
  Guid,
  ErrorStateService,
  LoginType,
  config
} from '@fgb/core';

@Component({
  selector: 'fgb-registration-provider-authentication',
  templateUrl: './registration-provider-authentication.component.html',
  styleUrls: ['./registration-provider-authentication.component.scss']
})
export class RegistrationProviderAuthenticationComponent implements OnInit {
  readonly stepType = StepType.ProviderAuthentication2;

  username: string = '';
  password: string = '';

  constructor(
    private registrationStepQuery: RegistrationStepQuery,
    private registrationStepService: RegistrationStepService,
    private logService: LoggingService,
    public errorService: ErrorStateService
  ) {}

  ngOnInit() {
    const step = this.registrationStepQuery.getStep(this.stepType);
    if (!step) {
      this.logService.warning('No step data found in the store for step', this.stepType);
      return;
    }

    // const availableAccounts = this.memberQuery.getAvailableAccounts() || [];
    // const oktaToken = this.registrationStepQuery.getQueryData('spareExternalRef');
    // if (availableAccounts && availableAccounts.length > 0 && oktaToken) {
    //   // Skip this step if we have an Okta token and accounts to choose from as we have already authenticated with MLBAM
    //   this.registrationStepService.submitRegistrationStepData(this.stepType, {
    //     LoginProviderID: ProviderName.MLBAM,
    //     LoginInputFields: [{ FieldName: 'okta', Value: oktaToken }]
    //   } as LoginModel).toPromise();
    //   return;
    // }

    const loginModel = step.Data as LoginModel;
    if (loginModel && loginModel.LoginInputFields) {
      const usernameField = loginModel.LoginInputFields.find(x => x.FieldName === 'Username');
      this.username = usernameField ? usernameField.Value : '';
    }
  }

  public submitStep() {
    this.logService.debug('Submitting...', this.username);

    let loginModel: LoginModel = {} as LoginModel;
    loginModel.LoginTypeID = LoginType.Portal;
    loginModel.LoginInputFields = [];
    loginModel.ReturnUrl = config.portalUrl;

    loginModel.LoginInputFields.push({
      FieldName: 'Username',
      Value: this.username,
      InputType: InputType.Text
    } as InputField);

    loginModel.LoginInputFields.push({
      FieldName: 'Password',
      Value: this.password,
      InputType: InputType.Password
    } as InputField);

    loginModel.LoginInputFields.push({
      FieldName: 'deviceGUID',
      Value: new Guid().toString().split('-').join(''),
      InputType: InputType.Hidden
    } as InputField);

    this.registrationStepService.submitRegistrationStepData(this.stepType, loginModel).toPromise();
  }
}
